import React from 'react';
import PropTypes from 'prop-types';

import { Typo } from 'uikit/content';

const VersioningPropertiesText = ({ value }) => (
  <Typo variant="b01" color="secondary">
    {value}
  </Typo>
);

VersioningPropertiesText.propTypes = {
  value: PropTypes.string.isRequired,
};

export default React.memo(VersioningPropertiesText);
